// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ids Multi Select Component */
/* Ids Dropdown Component */
.validation-message {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: flex;
  font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);
  margin-top: var(--ids-space-2xs);
  max-width: var(--ids-input-width-full);
}
.validation-message.has-custom-icon {
  color: var(--ids-icon-color-default);
}
.validation-message.disabled {
  color: var(--ids-input-color-text-disabled);
}
.validation-message .ids-icon {
  margin-inline-end: var(--ids-space-2xs);
}
.validation-message.alert {
  color: var(--ids-color-caution-default);
}
.validation-message.alert.disabled {
  color: var(--ids-color-yellow-30);
}
.validation-message.warning {
  color: var(--ids-color-warning-default);
}
.validation-message.warning.disabled {
  color: var(--ids-color-orange-30);
}
.validation-message.error {
  color: var(--ids-color-error-default);
}
.validation-message.error.disabled {
  color: var(--ids-color-red-30);
}
.validation-message.info {
  color: var(--ids-color-info-default);
}
.validation-message.info.disabled {
  color: var(--ids-color-blue-30);
}
.validation-message.success {
  color: var(--ids-color-success-default);
}
.validation-message.success.disabled {
  color: var(--ids-color-green-30);
}
.validation-message[hidden] {
  display: none;
}

.icon-error-tracker {
  position: absolute;
  color: var(--ids-input-error-tracker-color-background, var(--ids-color-red-60));
  top: 0;
  pointer-events: none;
}
.icon-error-tracker[dir=rtl] {
  transform: rotate(90deg);
  top: 0;
}

.icon-field-indicator {
  position: absolute;
  top: 0;
  pointer-events: none;
}
.icon-field-indicator[dir=rtl] {
  transform: rotate(90deg);
  top: 0;
}

.icon-field-indicator-info {
  display: var(--ids-field-indicator-info-visibility, flex);
  align-items: center;
  margin-inline-end: var(--ids-field-indicator-info-margin, var(--ids-space-xs));
  cursor: pointer;
  color: var(--ids-field-indicator-icon-color, --ids-color-info-default);
}

.field-indicator-neutral {
  --ids-field-indicator-icon-color: var(--ids-color-accent-neutral-weak);
}
.field-indicator-neutral .icon-field-indicator {
  color: var(--ids-color-accent-neutral-weak);
}

.field-indicator-info {
  --ids-field-indicator-icon-color: var(--ids-color-info-default);
}
.field-indicator-info .icon-field-indicator {
  color: var(--ids-color-info-default);
}

.field-indicator-success {
  --ids-field-indicator-icon-color: var(--ids-color-success-default);
}
.field-indicator-success .icon-field-indicator {
  color: var(--ids-color-success-default);
}

.field-indicator-caution {
  --ids-field-indicator-icon-color: var(--ids-color-caution-default);
}
.field-indicator-caution .icon-field-indicator {
  color: var(--ids-color-caution-default);
}

.field-indicator-warning {
  --ids-field-indicator-icon-color: var(--ids-color-warning-default);
}
.field-indicator-warning .icon-field-indicator {
  color: var(--ids-color-warning-default);
}

.field-indicator-error {
  --ids-field-indicator-icon-color: var(--ids-color-error-default);
}
.field-indicator-error .icon-field-indicator {
  color: var(--ids-color-error-default);
}

[class*=field-indicator-].has-focus .icon-field-indicator-info {
  display: none;
}

:host {
  --ids-button-tertiary-color-background-hover: var(--ids-color-transparent);
  --ids-button-tertiary-color-border-hover: var(--ids-color-transparent);
  --ids-button-tertiary-color-background-pressed: var(--ids-color-transparent);
  --ids-button-tertiary-color-border-pressed: var(--ids-color-transparent);
  display: block;
}
:host .ids-dropdown {
  display: inline-block;
  max-width: 100%;
  width: var(--ids-box-dropdown-width, auto);
}

:host([field-indicator]) {
  --ids-field-indicator-info-margin: 0;
}

:host([field-indicator][readonly]),
:host([field-indicator][disabled]) {
  --ids-field-indicator-info-visibility: none;
}

:host([hidden]) {
  display: none;
}

:host([label-position=inline-start]) ids-trigger-field::part(container) {
  justify-content: var(--ids-box-justify-content, flex-start);
}

ids-trigger-field[readonly-background]:not([disabled])::part(input) {
  cursor: var(--ids-cursor-pointer);
}

ids-trigger-field:not([autoselect])::part(input)::selection {
  background-color: var(--ids-color-transparent);
}

.ids-dropdown.is-open ids-trigger-field:not([autoselect])::part(input)::selection {
  background-color: var(--ids-dropdown-color-background-selected);
  color: var(--ids-dropdown-color-text-selected);
}

.ids-dropdown {
  display: block;
  position: relative;
}
.ids-dropdown ids-trigger-field[size=full] {
  display: block;
}
.ids-dropdown.full {
  display: block;
}
.ids-dropdown.full ids-trigger-field,
.ids-dropdown.full .ids-trigger-field {
  display: block;
}
.ids-dropdown ::slotted(ids-list-box) {
  height: var(--ids-popup-maxheight);
}

.trigger-icon {
  color: var(--ids-dropdown-color-icon);
  margin: 0 0 0 var(--ids-dropdown-space-text);
  position: relative;
  top: 0;
}

:host([mode=light]) .typeahead.is-open ids-trigger-field::part(field-container) {
  background-color: var(--ids-dropdown-typeahead-color-background);
}

:host([dir=rtl]) .trigger-icon {
  margin: 0 var(--ids-dropdown-space-text) 0 0;
}

::slotted(.sub-group) {
  border-top: 1px solid var(--ids-dropdown-separator-color-border);
  padding-top: var(--ids-dropdown-separator-padding);
}

.ids-dropdown.color-variant-borderless ids-trigger-field::part(field-container),
.ids-dropdown.color-variant-in-cell ids-trigger-field::part(field-container) {
  margin: 0;
  border-radius: 0;
}
.ids-dropdown.color-variant-borderless ids-trigger-field::part(label),
.ids-dropdown.color-variant-in-cell ids-trigger-field::part(label) {
  display: none;
}

.ids-dropdown.color-variant-borderless ids-trigger-field::part(container) {
  margin: -1px;
}
.ids-dropdown.color-variant-borderless ids-trigger-field::part(field-container) {
  box-shadow: none !important;
}
.ids-dropdown.color-variant-borderless.is-open .ids-trigger-field-slot-trigger-end {
  margin-block-start: 2px;
}
.ids-dropdown.color-variant-borderless.field-height-lg ids-trigger-field::part(input) {
  padding-inline: 12px;
  height: 50px;
}
.ids-dropdown.color-variant-borderless.field-height-lg.is-open .ids-trigger-field-slot-trigger-end {
  margin-inline-end: 3px;
}
.ids-dropdown.color-variant-borderless.field-height-md ids-trigger-field::part(input) {
  padding-inline: 13px;
  height: 40px;
}
.ids-dropdown.color-variant-borderless.field-height-md.is-open .ids-trigger-field-slot-trigger-end {
  margin-inline-end: 10px;
}
.ids-dropdown.color-variant-borderless.field-height-sm ids-trigger-field::part(input) {
  padding-inline: 9px;
  height: 35px;
}
.ids-dropdown.color-variant-borderless.field-height-sm.is-open .ids-trigger-field-slot-trigger-end {
  margin-inline-end: 3px;
}
.ids-dropdown.color-variant-borderless.field-height-xs ids-trigger-field::part(input) {
  padding-inline: 5px;
  height: 30px;
}
.ids-dropdown.color-variant-borderless.field-height-xs.is-open .ids-trigger-field-slot-trigger-end {
  margin-inline-end: -2px;
}
.ids-dropdown.color-variant-borderless.field-height-xxs ids-trigger-field::part(input) {
  padding-inline: 3px;
  height: 30px;
}
.ids-dropdown.color-variant-borderless.field-height-xxs.is-open .ids-trigger-field-slot-trigger-end {
  margin-inline-end: -1px;
  margin-block-start: -2px;
}

:host([combobox]) .ids-dropdown.color-variant-borderless .ids-trigger-field-slot-trigger-end {
  display: flex;
  align-items: center;
  margin-block-start: 2px;
}
:host([combobox]) .ids-dropdown.color-variant-borderless.field-height-lg .ids-trigger-field-slot-trigger-end {
  margin-inline-end: 3px;
  height: 48px;
}
:host([combobox]) .ids-dropdown.color-variant-borderless.field-height-md .ids-trigger-field-slot-trigger-end {
  margin-inline-end: -1px;
  height: 39px;
}
:host([combobox]) .ids-dropdown.color-variant-borderless.field-height-sm .ids-trigger-field-slot-trigger-end {
  margin-inline-end: -5px;
  height: 33px;
}
:host([combobox]) .ids-dropdown.color-variant-borderless.field-height-xs .ids-trigger-field-slot-trigger-end {
  margin-inline-end: -10px;
  height: 29px;
}
:host([combobox]) .ids-dropdown.color-variant-borderless.field-height-xxs .ids-trigger-field-slot-trigger-end {
  margin-inline-end: -10px;
  margin-block-start: 0;
}

.ids-dropdown.color-variant-in-cell ids-trigger-field::part(container) {
  margin: 1px 0;
}

.ids-dropdown.color-variant-module-nav {
  color: var(--ids-module-nav-search-input-text-color);
  display: block;
  margin-block-end: 0;
}
.ids-dropdown.color-variant-module-nav ::slotted(ids-list-box) {
  color: var(--ids-module-nav-search-input-text-color);
}
.ids-dropdown.color-variant-module-nav ::slotted(ids-list-box-option) {
  color: inherit;
}
.ids-dropdown.color-variant-module-nav ids-trigger-field::part(field-container) {
  background-color: var(--ids-module-nav-input-bg-color);
  border-radius: var(--ids-module-nav-common-border-radius);
  border: var(--ids-module-nav-input-border-width) solid var(--ids-module-nav-input-border-color);
  box-shadow: none;
  color: inherit;
  overflow: hidden;
}
.ids-dropdown.color-variant-module-nav ids-trigger-field:hover::part(field-container) {
  background-color: var(--ids-module-nav-input-hover-bg-color);
}
.ids-dropdown.color-variant-module-nav ids-trigger-field:active::part(field-container) {
  background-color: var(--ids-module-nav-item-selected-bg-color);
  border-color: var(--ids-module-nav-item-selected-text-color);
  color: var(--ids-module-nav-item-selected-text-color);
}
.ids-dropdown.color-variant-module-nav ids-trigger-field:focus-within::part(field-container) {
  background-color: var(--ids-module-nav-input-focus-bg-color);
}
.ids-dropdown.color-variant-module-nav ids-trigger-field::part(input) {
  background-color: var(--ids-color-transparent);
  color: inherit;
}
.ids-dropdown.color-variant-module-nav ids-trigger-field::part(trigger-button) {
  background-color: var(--ids-color-transparent);
}
.ids-dropdown.color-variant-module-nav ids-trigger-field::part(input::placeholder) {
  color: var(--ids-module-nav-search-input-placeholder-text-color);
}
.ids-dropdown.color-variant-module-nav ids-trigger-field::part(input:active) {
  color: var(--ids-module-nav-search-input-text-color);
}
.ids-dropdown.color-variant-module-nav ids-dropdown-list::part(dropdown-list) {
  max-width: var(--ids-module-nav-expanded-size);
  width: calc(var(--ids-module-nav-switcher-dropdown-width) + var(--ids-module-nav-switcher-button-gutter-size) + var(--ids-module-nav-switcher-button-size));
}
.ids-dropdown.color-variant-module-nav ids-list-box-option {
  min-height: var(--ids-module-nav-item-height);
}
.ids-dropdown.color-variant-module-nav .fieldset {
  display: contents;
}
.ids-dropdown.color-variant-module-nav .ids-input-field {
  padding-inline-start: var(--ids-module-nav-item-expanded-icon-text-space-size);
}

:host ids-dropdown-list {
  max-width: var(--ids-input-width-40);
}

:host([size=xs]) ids-dropdown-list {
  max-width: var(--ids-input-width-10);
}

:host([size=sm]) ids-dropdown-list {
  max-width: var(--ids-input-width-20);
}

:host([size=mm]) ids-dropdown-list {
  max-width: var(--ids-input-width-30);
}

:host([size=md]) ids-dropdown-list {
  max-width: var(--ids-input-width-40);
}

:host([size=lg]) ids-dropdown-list {
  max-width: var(--ids-input-width-50);
}

:host([size=full]) ids-dropdown-list {
  max-width: var(--ids-input-width-full);
}

:host ids-dropdown-list,
:host([size=full]) {
  width: var(--ids-input-width-full);
}

:host([list]:not([disabled])) {
  cursor: var(--ids-cursor-pointer);
}

:host([auto-size=true]) ids-trigger-field::part(input) {
  padding-inline-end: 0;
}

.ids-dropdown ids-trigger-field::part(clearable-button) {
  margin-inline-end: -6px;
}

.ids-checkbox {
  margin-bottom: 0;
}

ids-trigger-field ids-tag {
  align-self: center;
  display: flex;
  margin-top: var(--ids-space-2xs);
  margin-inline-start: var(--ids-space-2xs);
  max-width: 100%;
}
ids-trigger-field ids-tag[disabled]::part(tag) {
  cursor: var(--ids-cursor-default);
}
ids-trigger-field ids-tag ids-icon {
  padding-left: 6px;
  padding-right: 1px;
  width: 12px;
  top: 0;
}

:host([tags]:not([tags=false])),
:host(:not([typeahead]):not([tags])) {
  --ids-checkbox-padding-inline-start: 18px;
}
:host([tags]:not([tags=false])) ids-trigger-field::part(content-area),
:host(:not([typeahead]):not([tags])) ids-trigger-field::part(content-area) {
  display: flex;
  width: calc(100% - 38px);
  flex-wrap: wrap;
}
:host([tags]:not([tags=false])) ids-trigger-field::part(input),
:host(:not([typeahead]):not([tags])) ids-trigger-field::part(input) {
  opacity: 0;
  color: transparent;
  width: 0;
  padding: 0;
  flex: 1;
}
:host([tags]:not([tags=false])) ids-trigger-field::part(input)::placeholder,
:host(:not([typeahead]):not([tags])) ids-trigger-field::part(input)::placeholder {
  visibility: hidden;
}
:host([tags]:not([tags=false])) ids-trigger-field::part(input)::selection,
:host(:not([typeahead]):not([tags])) ids-trigger-field::part(input)::selection {
  color: var(--ids-color-transparent);
  background: var(--ids-color-transparent);
}
:host([tags]:not([tags=false])) ids-trigger-field ids-text,
:host(:not([typeahead]):not([tags])) ids-trigger-field ids-text {
  max-width: 100%;
}
:host([tags]:not([tags=false])) ids-trigger-field ids-text.placeholder,
:host(:not([typeahead]):not([tags])) ids-trigger-field ids-text.placeholder {
  color: var(--ids-multiselect-section-header-color);
}
:host([tags]:not([tags=false])) ids-trigger-field ids-text::part(text),
:host(:not([typeahead]):not([tags])) ids-trigger-field ids-text::part(text) {
  padding-inline-start: var(--ids-space-xs);
}
:host([tags]:not([tags=false])) ids-trigger-field[compact] ids-text::part(text), :host([tags]:not([tags=false])) ids-trigger-field[field-height=xs] ids-text::part(text),
:host(:not([typeahead]):not([tags])) ids-trigger-field[compact] ids-text::part(text),
:host(:not([typeahead]):not([tags])) ids-trigger-field[field-height=xs] ids-text::part(text) {
  padding-inline-start: var(--ids-space-2xs);
  font-size: var(--ids-multiselect-font-size);
}

:host(:not([tags])) ids-trigger-field ids-text.placeholder {
  color: var(--ids-multiselect-section-header-color);
}
:host(:not([tags])) ids-trigger-field ids-text.placeholder::part(text) {
  padding-inline-start: 0;
}

:host(.datagrid-editor) ids-trigger-field ids-text {
  margin-inline-start: 5px;
}

:host(:not([disabled])) .has-value ids-trigger-field::part(field-container) {
  cursor: var(--ids-cursor-pointer);
}

:host([disabled]) ids-trigger-field::part(field-container) {
  pointer-events: none;
}

:host .trigger-icon,
:host ids-trigger-button ids-icon {
  color: var(--ids-multiselect-dropdown-icon-color);
}

.is-open ids-trigger-field::part(field-container) {
  box-shadow: var(--ids-multiselect-dropdown-box-shadow);
}
.is-open ids-trigger-field::part(field-container):not(.error) {
  background-color: var(--ids-multiselect-open-background-color);
  border: var(--ids-multiselect-border-open);
}`, "",{"version":3,"sources":["webpack://./src/components/ids-multiselect/ids-multiselect.scss","webpack://./src/components/ids-dropdown/ids-dropdown.scss","webpack://./src/themes/mixins/ids-validation-mixin.scss","webpack://./src/themes/mixins/ids-core-mixins.scss","webpack://./src/themes/mixins/ids-error-tracker-mixin.scss","webpack://./src/themes/mixins/ids-field-indicator-mixin.scss"],"names":[],"mappings":"AAAA,+BAAA;ACAA,2BAAA;ACEA;ECQE,mCAAA;EACA,kCAAA;EDNA,aAAA;EACA,+EAAA;EACA,gCAAA;EACA,sCAAA;AFCF;AECE;EACE,oCAAA;AFCJ;AEEE;EACE,2CAAA;AFAJ;AEGE;EACE,uCAAA;AFDJ;AEIE;EACE,uCAAA;AFFJ;AEII;EACE,iCAAA;AFFN;AEME;EACE,uCAAA;AFJJ;AEMI;EACE,iCAAA;AFJN;AEQE;EACE,qCAAA;AFNJ;AEQI;EACE,8BAAA;AFNN;AEUE;EACE,oCAAA;AFRJ;AEUI;EACE,+BAAA;AFRN;AEYE;EACE,uCAAA;AFVJ;AEYI;EACE,gCAAA;AFVN;AEcE;EACE,aAAA;AFZJ;;AIlDA;EACE,kBAAA;EACA,+EAAA;EACA,MAAA;EACA,oBAAA;AJqDF;AInDE;EACE,wBAAA;EACA,MAAA;AJqDJ;;AK7DA;EACE,kBAAA;EACA,MAAA;EACA,oBAAA;ALgEF;AK9DE;EACE,wBAAA;EACA,MAAA;ALgEJ;;AK5DA;EACE,yDAAA;EACA,mBAAA;EACA,8EAAA;EACA,eAAA;EACA,sEAAA;AL+DF;;AK3CA;EAfE,sEAAA;AL8DF;AKrDE;EACE,2CAAA;ALuDJ;;AK9CA;EAnBE,+DAAA;ALqEF;AK5DE;EACE,oCAAA;AL8DJ;;AKjDA;EAvBE,kEAAA;AL4EF;AKnEE;EACE,uCAAA;ALqEJ;;AKpDA;EA3BE,kEAAA;ALmFF;AK1EE;EACE,uCAAA;AL4EJ;;AKvDA;EA/BE,kEAAA;AL0FF;AKjFE;EACE,uCAAA;ALmFJ;;AK1DA;EAnCE,gEAAA;ALiGF;AKxFE;EACE,qCAAA;AL0FJ;;AK5DE;EACE,aAAA;AL+DJ;;ACxHA;EACE,0EAAA;EACA,sEAAA;EACA,4EAAA;EACA,wEAAA;EAEA,cAAA;AD0HF;ACxHE;EACE,qBAAA;EACA,eAAA;EACA,0CAAA;AD0HJ;;ACtHA;EACE,oCAAA;ADyHF;;ACtHA;;EAEE,2CAAA;ADyHF;;ACtHA;EACE,aAAA;ADyHF;;ACnHI;EACE,2DAAA;ADsHN;;ACjHA;EACE,iCAAA;ADoHF;;AChHE;EACE,8CAAA;ADmHJ;;AC7GI;EACE,+DAAA;EACA,8CAAA;ADgHN;;AC1GA;EACE,cAAA;EACA,kBAAA;AD6GF;AC1GI;EACE,cAAA;AD4GN;ACxGE;EACE,cAAA;AD0GJ;ACxGI;;EAEE,cAAA;AD0GN;ACtGE;EACE,kCAAA;ADwGJ;;ACnGA;EACE,qCAAA;EACA,4CAAA;EACA,kBAAA;EACA,MAAA;ADsGF;;AClGE;EACE,gEAAA;ADqGJ;;ACjGA;EACE,4CAAA;ADoGF;;ACjGA;EACE,gEAAA;EACA,kDAAA;ADoGF;;AC9FE;;EACE,SAAA;EACA,gBAAA;ADkGJ;AC/FE;;EACE,aAAA;ADkGJ;;AC5FE;EACE,YAAA;AD+FJ;AC5FE;EACE,2BAAA;AD8FJ;AC1FI;EACE,uBAAA;AD4FN;ACvFI;EACE,oBAAA;EACA,YAAA;ADyFN;ACrFM;EACE,sBAAA;ADuFR;ACjFI;EACE,oBAAA;EACA,YAAA;ADmFN;AC/EM;EACE,uBAAA;ADiFR;AC3EI;EACE,mBAAA;EACA,YAAA;AD6EN;ACzEM;EACE,sBAAA;AD2ER;ACrEI;EACE,mBAAA;EACA,YAAA;ADuEN;ACnEM;EACE,uBAAA;ADqER;AC/DI;EACE,mBAAA;EACA,YAAA;ADiEN;AC7DM;EACE,uBAAA;EACA,wBAAA;AD+DR;;ACvDI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AD0DN;ACtDM;EACE,sBAAA;EACA,YAAA;ADwDR;ACnDM;EACE,uBAAA;EACA,YAAA;ADqDR;AChDM;EACE,uBAAA;EACA,YAAA;ADkDR;AC7CM;EACE,wBAAA;EACA,YAAA;AD+CR;AC1CM;EACE,wBAAA;EACA,qBAAA;AD4CR;;ACpCE;EACE,aAAA;ADuCJ;;AClCA;EACE,oDAAA;EACA,cAAA;EACA,mBAAA;ADqCF;ACnCE;EACE,oDAAA;ADqCJ;AClCE;EACE,cAAA;ADoCJ;ACjCE;EACE,sDAAA;EACA,yDAAA;EACA,+FAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;ADmCJ;AChCE;EACE,4DAAA;ADkCJ;AC/BE;EACE,8DAAA;EACA,4DAAA;EACA,qDAAA;ADiCJ;AC9BE;EACE,4DAAA;ADgCJ;AC7BE;EACE,8CAAA;EACA,cAAA;AD+BJ;AC5BE;EACE,8CAAA;AD8BJ;AC3BE;EACE,gEAAA;AD6BJ;AC1BE;EACE,oDAAA;AD4BJ;ACzBE;EACE,8CAAA;EACA,2JAAA;AD2BJ;ACxBE;EACE,6CAAA;AD0BJ;ACvBE;EACE,iBAAA;ADyBJ;ACtBE;EACE,8EAAA;ADwBJ;;ACnBA;EACE,oCAAA;ADsBF;;ACnBA;EACE,oCAAA;ADsBF;;ACnBA;EACE,oCAAA;ADsBF;;ACnBA;EACE,oCAAA;ADsBF;;ACnBA;EACE,oCAAA;ADsBF;;ACnBA;EACE,oCAAA;ADsBF;;ACnBA;EACE,sCAAA;ADsBF;;ACnBA;;EAEE,kCAAA;ADsBF;;AClBA;EACE,iCAAA;ADqBF;;ACjBE;EACE,qBAAA;ADoBJ;;AChBA;EACE,uBAAA;ADmBF;;AAxYA;EACE,gBAAA;AA2YF;;AAvYE;EACE,kBAAA;EACA,aAAA;EACA,gCAAA;EACA,yCAAA;EACA,eAAA;AA0YJ;AAxYI;EACE,iCAAA;AA0YN;AAvYI;EACE,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,MAAA;AAyYN;;AApYA;;EAEE,yCAAA;AAuYF;AApYI;;EACE,aAAA;EACA,wBAAA;EACA,eAAA;AAuYN;AApYI;;EACE,UAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,OAAA;AAuYN;AArYM;;EACE,kBAAA;AAwYR;AArYM;;EACE,mCAAA;EACA,wCAAA;AAwYR;AApYI;;EACE,eAAA;AAuYN;AArYM;;EACE,kDAAA;AAwYR;AArYM;;EACE,yCAAA;AAwYR;AAlYM;;;EACE,0CAAA;EACA,2CAAA;AAsYR;;AA/XE;EACE,kDAAA;AAkYJ;AAhYI;EACE,uBAAA;AAkYN;;AA5XE;EACE,wBAAA;AA+XJ;;AAxXM;EACE,iCAAA;AA2XR;;AAnXI;EACE,oBAAA;AAsXN;;AAhXE;;EAEE,iDAAA;AAmXJ;;AA9WE;EACE,sDAAA;AAiXJ;AA/WI;EACE,8DAAA;EACA,0CAAA;AAiXN","sourcesContent":["/* Ids Multi Select Component */\n@use '../ids-dropdown/ids-dropdown' as *;\n\n.ids-checkbox {\n  margin-bottom: 0;\n}\n\nids-trigger-field {\n  ids-tag {\n    align-self: center;\n    display: flex;\n    margin-top: var(--ids-space-2xs);\n    margin-inline-start: var(--ids-space-2xs);\n    max-width: 100%;\n\n    &[disabled]::part(tag) {\n      cursor: var(--ids-cursor-default);\n    }\n\n    ids-icon{\n      padding-left: 6px;\n      padding-right: 1px;\n      width: 12px;\n      top: 0;\n    }\n  }\n}\n\n:host([tags]:not([tags=\"false\"])),\n:host(:not([typeahead]):not([tags])) {\n  --ids-checkbox-padding-inline-start: 18px;\n\n  ids-trigger-field {\n    &::part(content-area) {\n      display: flex;\n      width: calc(100% - 38px);\n      flex-wrap: wrap;\n    }\n\n    &::part(input) {\n      opacity: 0;\n      color: transparent;\n      width: 0;\n      padding: 0;\n      flex: 1;\n\n      &::placeholder {\n        visibility: hidden;\n      }\n\n      &::selection {\n        color: var(--ids-color-transparent);\n        background: var(--ids-color-transparent);\n      }\n    }\n\n    ids-text {\n      max-width: 100%;\n\n      &.placeholder {\n        color: var(--ids-multiselect-section-header-color);\n      }\n\n      &::part(text) {\n        padding-inline-start: var(--ids-space-xs);\n      }\n    }\n\n    &[compact],\n    &[field-height='xs'] {\n      ids-text::part(text) {\n        padding-inline-start: var(--ids-space-2xs);\n        font-size: var(--ids-multiselect-font-size);\n      }\n    }\n  }\n}\n\n:host(:not([tags])) ids-trigger-field {\n  ids-text.placeholder {\n    color: var(--ids-multiselect-section-header-color);\n\n    &::part(text) {\n      padding-inline-start: 0;\n    }\n  }\n}\n\n:host(.datagrid-editor) ids-trigger-field {\n  ids-text {\n    margin-inline-start: 5px;\n  }\n}\n\n:host(:not([disabled])) {\n  .has-value {\n    ids-trigger-field {\n      &::part(field-container) {\n        cursor: var(--ids-cursor-pointer);\n      }\n    }\n  }\n}\n\n:host([disabled]) {\n  ids-trigger-field {\n    &::part(field-container) {\n      pointer-events: none;\n    }\n  }\n}\n\n:host {\n  .trigger-icon,\n  ids-trigger-button ids-icon {\n    color: var(--ids-multiselect-dropdown-icon-color);\n  }\n}\n\n.is-open {\n  ids-trigger-field::part(field-container) {\n    box-shadow: var(--ids-multiselect-dropdown-box-shadow);\n\n    &:not(.error) {\n      background-color: var(--ids-multiselect-open-background-color);\n      border: var(--ids-multiselect-border-open);\n    }\n  }\n}\n","/* Ids Dropdown Component */\n@use '../../themes/mixins/ids-validation-mixin';\n@use '../../themes/mixins/ids-core-mixins' as *;\n@use '../../themes/mixins/ids-error-tracker-mixin' as *;\n@use '../../themes/mixins/ids-field-indicator-mixin' as *;\n\n:host {\n  --ids-button-tertiary-color-background-hover: var(--ids-color-transparent);\n  --ids-button-tertiary-color-border-hover: var(--ids-color-transparent);\n  --ids-button-tertiary-color-background-pressed: var(--ids-color-transparent);\n  --ids-button-tertiary-color-border-pressed: var(--ids-color-transparent);\n\n  display: block;\n\n  .ids-dropdown {\n    display: inline-block;\n    max-width: 100%;\n    width: var(--ids-box-dropdown-width, auto);\n  }\n}\n\n:host([field-indicator]) {\n  --ids-field-indicator-info-margin: 0;\n}\n\n:host([field-indicator][readonly]),\n:host([field-indicator][disabled]) {\n  --ids-field-indicator-info-visibility: none;\n}\n\n:host([hidden]) {\n  display: none;\n}\n\n\n:host([label-position=\"inline-start\"]) {\n  ids-trigger-field {\n    &::part(container) {\n      justify-content: var(--ids-box-justify-content, flex-start);\n    }\n  }\n}\n\nids-trigger-field[readonly-background]:not([disabled])::part(input) {\n  cursor: var(--ids-cursor-pointer);\n}\n\nids-trigger-field:not([autoselect])::part(input) {\n  &::selection {\n    background-color: var(--ids-color-transparent);\n  }\n}\n\n.ids-dropdown.is-open {\n  ids-trigger-field:not([autoselect])::part(input) {\n    &::selection {\n      background-color: var(--ids-dropdown-color-background-selected);\n      color: var(--ids-dropdown-color-text-selected);\n    }\n  }\n}\n\n// Most Styles are in list-box, popup and trigger field\n.ids-dropdown {\n  display: block;\n  position: relative;\n\n  ids-trigger-field {\n    &[size='full'] {\n      display: block;\n    }\n  }\n\n  &.full {\n    display: block;\n\n    ids-trigger-field,\n    .ids-trigger-field {\n      display: block;\n    }\n  }\n\n  ::slotted(ids-list-box) {\n    height: var(--ids-popup-maxheight);\n  }\n}\n\n// Icon Placement\n.trigger-icon {\n  color: var(--ids-dropdown-color-icon);\n  margin: 0 0 0 var(--ids-dropdown-space-text);\n  position: relative;\n  top: 0;\n}\n\n:host([mode='light']) {\n  .typeahead.is-open ids-trigger-field::part(field-container) {\n    background-color: var(--ids-dropdown-typeahead-color-background);\n  }\n}\n\n:host([dir='rtl']) .trigger-icon {\n  margin: 0 var(--ids-dropdown-space-text) 0 0;\n}\n\n::slotted(.sub-group) {\n  border-top: 1px solid var(--ids-dropdown-separator-color-border);\n  padding-top: var(--ids-dropdown-separator-padding);\n}\n\n// Dropdown Editor\n.ids-dropdown.color-variant-borderless,\n.ids-dropdown.color-variant-in-cell {\n  ids-trigger-field::part(field-container) {\n    margin: 0;\n    border-radius: 0;\n  }\n\n  ids-trigger-field::part(label) {\n    display: none;\n  }\n}\n\n// Dropdown Editor Borderless\n.ids-dropdown.color-variant-borderless {\n  ids-trigger-field::part(container) {\n    margin: -1px;\n  }\n\n  ids-trigger-field::part(field-container) {\n    box-shadow: none !important;\n  }\n\n  &.is-open {\n    .ids-trigger-field-slot-trigger-end {\n      margin-block-start: 2px;\n    }\n  }\n\n  &.field-height-lg {\n    ids-trigger-field::part(input) {\n      padding-inline: 12px;\n      height: 50px;\n    }\n\n    &.is-open {\n      .ids-trigger-field-slot-trigger-end {\n        margin-inline-end: 3px;\n      }\n    }\n  }\n\n  &.field-height-md {\n    ids-trigger-field::part(input) {\n      padding-inline: 13px;\n      height: 40px;\n    }\n\n    &.is-open {\n      .ids-trigger-field-slot-trigger-end {\n        margin-inline-end: 10px;\n      }\n    }\n  }\n\n  &.field-height-sm {\n    ids-trigger-field::part(input) {\n      padding-inline: 9px;\n      height: 35px;\n    }\n\n    &.is-open {\n      .ids-trigger-field-slot-trigger-end {\n        margin-inline-end: 3px;\n      }\n    }\n  }\n\n  &.field-height-xs {\n    ids-trigger-field::part(input) {\n      padding-inline: 5px;\n      height: 30px;\n    }\n\n    &.is-open {\n      .ids-trigger-field-slot-trigger-end {\n        margin-inline-end: -2px;\n      }\n    }\n  }\n\n  &.field-height-xxs {\n    ids-trigger-field::part(input) {\n      padding-inline: 3px;\n      height: 30px;\n    }\n\n    &.is-open {\n      .ids-trigger-field-slot-trigger-end {\n        margin-inline-end: -1px;\n        margin-block-start: -2px;\n      }\n    }\n  }\n}\n\n:host([combobox]) {\n  .ids-dropdown.color-variant-borderless {\n    .ids-trigger-field-slot-trigger-end {\n      display: flex;\n      align-items: center;\n      margin-block-start: 2px;\n    }\n\n    &.field-height-lg {\n      .ids-trigger-field-slot-trigger-end {\n        margin-inline-end: 3px;\n        height: 48px;\n      }\n    }\n\n    &.field-height-md {\n      .ids-trigger-field-slot-trigger-end {\n        margin-inline-end: -1px;\n        height: 39px;\n      }\n    }\n\n    &.field-height-sm {\n      .ids-trigger-field-slot-trigger-end {\n        margin-inline-end: -5px;\n        height: 33px;\n      }\n    }\n\n    &.field-height-xs {\n      .ids-trigger-field-slot-trigger-end {\n        margin-inline-end: -10px;\n        height: 29px;\n      }\n    }\n\n    &.field-height-xxs {\n      .ids-trigger-field-slot-trigger-end {\n        margin-inline-end: -10px;\n        margin-block-start: 0;\n      }\n    }\n  }\n}\n\n// Dropdown Editor In Cell\n.ids-dropdown.color-variant-in-cell {\n  ids-trigger-field::part(container) {\n    margin: 1px 0;\n  }\n}\n\n// Module Nav Color Variant\n.ids-dropdown.color-variant-module-nav {\n  color: var(--ids-module-nav-search-input-text-color);\n  display: block;\n  margin-block-end: 0;\n\n  ::slotted(ids-list-box) {\n    color: var(--ids-module-nav-search-input-text-color);\n  }\n\n  ::slotted(ids-list-box-option) {\n    color: inherit;\n  }\n\n  ids-trigger-field::part(field-container) {\n    background-color: var(--ids-module-nav-input-bg-color);\n    border-radius: var(--ids-module-nav-common-border-radius);\n    border: var(--ids-module-nav-input-border-width) solid var(--ids-module-nav-input-border-color);\n    box-shadow: none;\n    color: inherit;\n    overflow: hidden;\n  }\n\n  ids-trigger-field:hover::part(field-container) {\n    background-color: var(--ids-module-nav-input-hover-bg-color);\n  }\n\n  ids-trigger-field:active::part(field-container) {\n    background-color: var(--ids-module-nav-item-selected-bg-color);\n    border-color: var(--ids-module-nav-item-selected-text-color);\n    color: var(--ids-module-nav-item-selected-text-color);\n  }\n\n  ids-trigger-field:focus-within::part(field-container) {\n    background-color: var(--ids-module-nav-input-focus-bg-color);\n  }\n\n  ids-trigger-field::part(input) {\n    background-color: var(--ids-color-transparent);\n    color: inherit;\n  }\n\n  ids-trigger-field::part(trigger-button) {\n    background-color: var(--ids-color-transparent);\n  }\n\n  ids-trigger-field::part(input::placeholder) {\n    color: var(--ids-module-nav-search-input-placeholder-text-color);\n  }\n\n  ids-trigger-field::part(input:active) {\n    color: var(--ids-module-nav-search-input-text-color);\n  }\n\n  ids-dropdown-list::part(dropdown-list) {\n    max-width: var(--ids-module-nav-expanded-size);\n    width: calc(var(--ids-module-nav-switcher-dropdown-width) + var(--ids-module-nav-switcher-button-gutter-size) + var(--ids-module-nav-switcher-button-size));\n  }\n\n  ids-list-box-option {\n    min-height: var(--ids-module-nav-item-height);\n  }\n\n  .fieldset {\n    display: contents;\n  }\n\n  .ids-input-field {\n    padding-inline-start: var(--ids-module-nav-item-expanded-icon-text-space-size);\n  }\n}\n\n// Dropdown menu width\n:host ids-dropdown-list {\n  max-width: var(--ids-input-width-40);\n}\n\n:host([size='xs']) ids-dropdown-list {\n  max-width: var(--ids-input-width-10);\n}\n\n:host([size='sm']) ids-dropdown-list {\n  max-width: var(--ids-input-width-20);\n}\n\n:host([size='mm']) ids-dropdown-list {\n  max-width: var(--ids-input-width-30);\n}\n\n:host([size='md']) ids-dropdown-list {\n  max-width: var(--ids-input-width-40);\n}\n\n:host([size='lg']) ids-dropdown-list {\n  max-width: var(--ids-input-width-50);\n}\n\n:host([size='full']) ids-dropdown-list {\n  max-width: var(--ids-input-width-full);\n}\n\n:host ids-dropdown-list,\n:host([size='full']) {\n  width: var(--ids-input-width-full);\n}\n\n// Change state for external dropdown list\n:host([list]:not([disabled])) {\n  cursor: var(--ids-cursor-pointer);\n}\n\n:host([auto-size=\"true\"]) {\n  ids-trigger-field::part(input) {\n    padding-inline-end: 0;\n  }\n}\n\n.ids-dropdown ids-trigger-field::part(clearable-button) {\n  margin-inline-end: -6px;\n}\n","@use '../../themes/mixins/ids-core-mixins' as mixins;\n\n.validation-message {\n  @include mixins.antialiased();\n\n  display: flex;\n  font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);\n  margin-top: var(--ids-space-2xs);\n  max-width: var(--ids-input-width-full);\n\n  &.has-custom-icon {\n    color: var(--ids-icon-color-default);\n  }\n\n  &.disabled {\n    color: var(--ids-input-color-text-disabled);\n  }\n\n  .ids-icon {\n    margin-inline-end: var(--ids-space-2xs);\n  }\n\n  &.alert {\n    color: var(--ids-color-caution-default);\n\n    &.disabled {\n      color: var(--ids-color-yellow-30);\n    }\n  }\n\n  &.warning {\n    color: var(--ids-color-warning-default);\n\n    &.disabled {\n      color: var(--ids-color-orange-30);\n    }\n  }\n\n  &.error {\n    color: var(--ids-color-error-default);\n\n    &.disabled {\n      color: var(--ids-color-red-30);\n    }\n  }\n\n  &.info {\n    color: var(--ids-color-info-default);\n\n    &.disabled {\n      color: var(--ids-color-blue-30);\n    }\n  }\n\n  &.success {\n    color: var(--ids-color-success-default);\n\n    &.disabled {\n      color: var(--ids-color-green-30);\n    }\n  }\n\n  &[hidden] {\n    display: none;\n  }\n}\n","// Breakpoints - this cant be tokens\n$breakpoint-xxl: 2463px;\n$breakpoint-xl: 1183px;\n$breakpoint-lg: 928px;\n$breakpoint-md: 927px;\n$breakpoint-sm: 767px;\n$breakpoint-xs: 320px;\n\n// Sets Text Antialiasing\n@mixin antialiased {\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n// vendor prefixed transitions for regular attributes (non-vendor prefixed)\n@mixin transition($transitions-list...) {\n  @each $prefix in $prefixes {\n    #{$prefix}transition: $transitions-list;\n  }\n}\n\n// make the text invisible visually but readable by screen readers\n@mixin audible() {\n  /* stylelint-disable-next-line property-no-deprecated */\n  clip: rect(0, 0, 0, 0);\n  color: var(--ids-color-text-default);\n  height: 0;\n  line-height: 0;\n  min-height: 0;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n}\n","// General Error-Tracker icon placement\n.icon-error-tracker {\n  position: absolute;\n  color: var(--ids-input-error-tracker-color-background, var(--ids-color-red-60));\n  top: 0;\n  pointer-events: none;\n\n  &[dir='rtl'] {\n    transform: rotate(90deg);\n    top: 0;\n  }\n}\n","// Field Indicator icon placement\n.icon-field-indicator {\n  position: absolute;\n  top: 0;\n  pointer-events: none;\n\n  &[dir='rtl'] {\n    transform: rotate(90deg);\n    top: 0;\n  }\n}\n\n.icon-field-indicator-info {\n  display: var(--ids-field-indicator-info-visibility, flex);\n  align-items: center;\n  margin-inline-end: var(--ids-field-indicator-info-margin, var(--ids-space-xs));\n  cursor: pointer;\n  color: var(--ids-field-indicator-icon-color, --ids-color-info-default);\n}\n\n// Mixin to apply field indicator color variables\n@mixin field-indicator-color($color, $border-color: null) {\n  --ids-field-indicator-icon-color: #{$color};\n\n  @if $border-color {\n    --ids-input-border-default-color: #{$border-color};\n    --ids-input-color-border-hover: #{$border-color};\n    --ids-input-color-border-disabled: #{$border-color};\n    --ids-input-color-border-focus: #{$border-color};\n  }\n\n  .icon-field-indicator {\n    color: #{$color};\n  }\n}\n\n// Field indicator type classes — applied to the field container.\n.field-indicator-neutral {\n  @include field-indicator-color(var(--ids-color-accent-neutral-weak));\n}\n\n.field-indicator-info {\n  @include field-indicator-color(var(--ids-color-info-default));\n}\n\n.field-indicator-success {\n  @include field-indicator-color(var(--ids-color-success-default));\n}\n\n.field-indicator-caution {\n  @include field-indicator-color(var(--ids-color-caution-default));\n}\n\n.field-indicator-warning {\n  @include field-indicator-color(var(--ids-color-warning-default));\n}\n\n.field-indicator-error {\n  @include field-indicator-color(var(--ids-color-error-default));\n}\n\n[class*=\"field-indicator-\"].has-focus {\n  .icon-field-indicator-info {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
